<template>
  <div v-wechat-title="titleTop" class="allBack">
    <div class="topLogoLine">
        <img src="/img/toplogo.png">
    </div>
    <div class="bodyRect">
        <div class="title1">船宿行程调查问卷</div>
        <div class="userRect">
            <div class="headicon"><img :src="data.icon?data.icon:'/img/defaultIcon.jpg'"/></div>
            <div class="userName">{{data.nickName?data.nickName:'游客'}}</div>
            <div class="userDate">{{data.boatName}} {{formatDate(data.tripDate,'yyyy-MM-dd')}}</div>
        </div>
        <div class="scoreRect">
            <van-row>
                <van-col span="8">船只硬件</van-col>
                <van-col span="16" style="padding-top:0.2em;" ><van-rate v-model="data.score1" :readonly="data.isLock"/></van-col>
            </van-row>
            <van-row>
                <van-col span="8">船员服务</van-col>
                <van-col span="16" style="padding-top:0.2em;"><van-rate v-model="data.score2" :readonly="data.isLock" /></van-col>
            </van-row>
            <van-row>
                <van-col span="8">行程餐食</van-col>
                <van-col span="16" style="padding-top:0.2em;" ><van-rate v-model="data.score3" :readonly="data.isLock" /></van-col>
            </van-row>
            <van-row>
                <van-col span="8">潜导态度</van-col>
                <van-col span="16" style="padding-top:0.2em;" ><van-rate v-model="data.score4" :readonly="data.isLock" /></van-col>
            </van-row>
            <van-row>
                <van-col span="8">行程性价比</van-col>
                <van-col span="16" style="padding-top:0.2em;" ><van-rate v-model="data.score5" :readonly="data.isLock" /></van-col>
            </van-row>
        </div>
        <div class="title2">发表评论</div>
        <div class="inputRect">
            <van-field
                style="background-color: #F8F9FA;"
                v-model="data.about"
                :readonly="data.isLock"
                rows="5"
                autosize
                type="textarea"
                placeholder="你觉得本次行程最大的亮点是?"
                />
        </div>
        <div class="buttonRect">
            <van-button :disabled="data.isLock" :loading="buttonLoading" type="primary" size="large" color="linear-gradient(to right, #11BDFA, #198EFE)" @click="onEdit">提交评价</van-button>
            <div class="aboutStr" v-if="data.isLock">{{errMeg}}</div>
        </div>
    </div>
    
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button,Rate,Field   } from 'vant'
import { ShowMoney, GetEnumText, formatDate,MyNotify } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Rate.name]: Rate,
    [Field.name]: Field,
  },
  data() {
    return {
      titleTop: '船宿行程调查问卷',
      hashCode:undefined,
      buttonLoading:false,
      errMeg:'评论已经发布,无法进行修改,如需帮助请联系客服!',
      data:{
        score1:0,
        score2:0,
        score3:0,
        score4:0,
        score5:0,
        about:'',
        icon:'',
        nickName:'',
        boatName:'',
        tripDate:new Date(),
        isLock:false,

      }
    }
  },

  created() {
    this.hashCode = this.$route.params.id
    this.onInit();
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    MyNotify,
    onInit(callback) {
      request({
        url: '/storeHelper/getLiveaboardCommentInfo',
        method: 'post',
        params: {
          code: this.hashCode
        }
      }).then(response => {
        if (!response.success) {
          MyNotify('error', response.message, 10000)
          this.data.isLock=true;
          this.errMeg = response.message;
          return
        }
        this.data = response.data;
      })
    },
    onEdit(){
        if(this.data.score1<0||this.data.score2<0||this.data.score3<0||this.data.score4<0||this.data.score5<0)
        {
            MyNotify('error', '请对每一个项目进行评分!', 2000)
            return
        }
        if(this.data.about.length<10)
        {
            MyNotify('error', '请填写最少10个字的评论!', 2000)
            return
        }
        this.buttonLoading=true;
        request({
            url: '/storeHelper/UpdateLiveaboardCommentInfo',
            method: 'post',
            data: this.data
        }).then(response => {
            this.buttonLoading=false;
            if (!response.success) {
                MyNotify('error', '读取数据失败!', 2000)
                return
            }
            this.data.isLock=true;
            MyNotify('success', '发布成功,感谢您的填写!', 2000)
        })
    }
  }
}
</script>
<style scoped>
.allBack{
    background-color: #fff;
    min-height: 100vh;
}
.topLogoLine{
    height: 3em;
    padding: 0.5em 1em;
    border-bottom: 1px solid #e6e6e6;
}
.topLogoLine img{
    height: 100%;
}
.bodyRect{
    background: #fff;
}
.title1{
    padding: 1em;
}
.userRect{
    position: relative;
    height: 5em;
}
.userRect .headicon{
    position: absolute;
    left: 1em;
    width: 4em;
    height: 4em;
    border-radius: 4em;
    overflow: hidden;
}
.userRect .headicon img{
    width: 100%;
    height: 100%;
}
.userRect .userName{
    margin-left: 6.5em;
    padding-top: 0.5em;
    font-size: 0.9em;
}
.userRect .userDate{
    margin-left: 6.5em;
    margin-top: 0.5em;
    font-size: 0.9em;
    color: #777777;
}
.scoreRect{
    padding: 1em;
    margin: 0 1em;
    border: 1px solid #E6E6E6;
    line-height: 2.5em;
}

.title2{
    padding: 1em;
    color: #1258AD;
}
.inputRect{
   padding: 0 1em;
}
.buttonRect{
    padding: 1em;
}
.aboutStr{
    color: #777;
    font-size: 0.7em;
    text-align: center;
    margin-top: 0.5em;
}
</style>
